export default "__VITE_ASSET__BS3ZyYAq__"